import React from 'react'
import { AiOutlineHome } from 'react-icons/ai'
import { BsChatSquareText, BsChatText } from 'react-icons/bs'
import { TbBrandYoutube } from 'react-icons/tb'
import { FaRegHeart } from 'react-icons/fa'
import { HiOutlineUsers } from 'react-icons/hi'
import { MdSlowMotionVideo } from 'react-icons/md'

import Friends from '../friends/Friends'
import Relation from '../relation/Relation'
import UserAppContext from '../../hook/UserAppContext'

const ContentData = ({isSetModal}) => {

      const {user, data} = UserAppContext()
      const {infordata, friends, relation, videos} = user.user 

      const openModal = () => {
            isSetModal(true)
      }

      return (
            <div className="content_data">
                  <div className="data_row nav">
                        <h2 className="nav_title">Meet Me Here</h2>
                        <div className="nav_menu">
                              <a href={infordata.data || infordata.homepage === "" ? "https://xat.com" : infordata.homepage} target="_blank" rel="noreferrer" data-tooltip="Homepage"><AiOutlineHome/></a>
                              <a href={infordata.data || infordata.xat_room === "" ? "https://xat.com" : infordata.xat_room} target="_blank" rel="noreferrer" data-tooltip="XatRoom"><BsChatText/></a>
                              <a href={infordata.data || infordata.forum === "" ? "https://forum.xat.com" : infordata.forum} target="_blank" rel="noreferrer" data-tooltip="Forum"><BsChatSquareText/></a>
                        </div>
                  </div>
                  <div className="data_row video">
                        {
                              (!videos.data) 
                                    ?
                                          <div className="row_content">
                                                <div className="row_content_left video">
                                                      <h3>{videos[0].title}</h3>
                                                      <button className="btn_video" onClick={() => openModal()}><MdSlowMotionVideo /></button>
                                                </div>
                                                <div className="row_content__right">
                                                      <h2>Video</h2>
                                                      <div className="row_icon"><TbBrandYoutube /></div>
                                                </div>
                                          </div>
                                    : ''
                        }
                        
                  </div>
                  <div className="data_row friend">
                        {
                              (!friends.data) 
                                    ?
                                          <div className="row_content">
                                                <div className="row_content_left friend">
                                                      <Friends friends={friends} />
                                                </div>
                                                <div className="row_content__right">
                                                      <h2>Friends</h2>
                                                      <div className="row_icon"><HiOutlineUsers /></div>
                                                </div>
                                          </div>
                                    : ''
                        }
                        
                  </div>
                  <div className="data_row relation">
                        {
                              !relation.data 
                                    ?
                                          <div className="row_content">
                                                <div className="row_content_left">
                                                      <Relation relation={relation} data={data}/>
                                                </div>
                                                <div className="row_content__right">
                                                      <h2>{relation.data ? "Relation" : relation.relation_type}</h2>
                                                      <div className="row_icon"><FaRegHeart /></div>
                                                </div>
                                          </div>
                                    : ''
                        }
                        
                  </div>
            </div>
      )
}

export default ContentData
